import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
  isMobileDevice: boolean;
  sellerAppDownloadUrl: string;
}

// Function to detect if the current device is mobile
const detectMobileDevice = (): boolean => {
  return window.innerWidth <= 768;
};

const initialState: UiState = {
  isMobileDevice: detectMobileDevice(),
  sellerAppDownloadUrl: "",
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsMobileDevice: (state, action: PayloadAction<boolean>) => {
      state.isMobileDevice = action.payload;
    },
    checkDeviceType: (state) => {
      state.isMobileDevice = detectMobileDevice();
    },
    setSellerAppDownloadUrl: (state, action: PayloadAction<string>) => {
      state.sellerAppDownloadUrl = action.payload;
    },
  },
});

export const { setIsMobileDevice, checkDeviceType, setSellerAppDownloadUrl } = uiSlice.actions;
export default uiSlice.reducer; 